export enum EditorModeEnums {
    /**
     * Create a new data set
     */
    CREATE = 0,
    /**
     * Edit an existing data set
     */
    EDIT = 1,
    /**
     * Clone/copy an existing data set
     */
    CLONE = 2,
    /**
     * Edit an unsynced event
     */
    EDIT_UNSYNCED = 3,
    /**
     * Fallback value in error case
     */
    UNKNOWN = 999,
}
